export default "__VITE_ASSET__BYfI7IqV__"